module.exports = require("core-js/library/fn/object/define-property");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/core-js/object/define-property.js
// module id = 1648
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 20 21 22 25